<ng-container *ngIf="!isCreating; else elseTemplate">
    <form
        [formGroup]="form"
        class="flex  flex-column"
        autocomplete="off"
        (ngSubmit)="onSubmit()"
    >
        <div class="grid edit-container ">
            <div class="col-12 section-header">
                <h4>{{'LABEL.PROJECT_SETTINGS' | translate}}</h4>
            </div>
            <div class="col-12 md:col-6 xl:col-4">
                <p-image
                    class="edit-image"
                    *ngIf="filePhotoUrl$ | async; let filePhotoUrl"
                    [src]="filePhotoUrl"
                    alt="Image"
                    [preview]="true"
                ></p-image>
                <div
                    *ngIf="!(filePhotoUrl$ | async)"
                    class="flex flex-column justify-content-center align-items-stretch text-center p-0 mb-4"
                >
                    <div class="flex justify-content-center border-round border-1 border-dashed border-200 surface-50 py-8 px-4 text-400 font-italic">
                        <span class="py-4">{{'LABEL.NO_PROJECT_COVER_IMAGE_YET' | translate}}</span>
                    </div>
                </div>

                <lib-prime-upload-files
                    *ngIf="id"
                    [path]="pathFiles"
                    [collection]="'files'"
                    [canView]="false"
                    [files$]="filesPhotoToDisplay$"
                    [canUpload]="filesPhotoCanUpload$ | async"
                    [ref]="{id:id, col:'projects', type:'image'}"
                    [maxFiles]="1"
                    fileTypes="image/png, image/jpeg"
                ></lib-prime-upload-files>
            </div>
            <div class="col-12 md:col-6 xl:col-8 formgrid grid p-fluid form-content">
                <div class="field col-12">
                    <label for="_name">{{'LABEL.NAME' | translate}}</label>
                    <input
                        pInputText
                        id="_name"
                        formControlName="name"
                        [placeholder]="'PLACEHOLDER.PROJECT_NAME_EX' | translate"
                        onfocus="this.select()"
                        autofocus
                        [ngClass]="{'ng-invalid ng-dirty' : isControlValid('name')}"
                    >
                    <small
                        *ngIf="isControlValid('name')"
                        id="_name-help"
                        class="p-error block"
                    >
                        {{getErrorMessage('name') | translate}}
                    </small>
                </div>
                <!-- Short name -->
                <div class="field col-6">
                    <label for="_displayName">{{'LABEL.SHORT_NAME' | translate}}</label>
                    <input
                        pInputText
                        id="_displayName"
                        formControlName="displayName"
                        [placeholder]="'PLACEHOLDER.PROJECT_DISPLAY_NAME_EX' | translate"
                        onfocus="this.select()"
                        [ngClass]="{'ng-invalid ng-dirty' : isControlValid('displayName')}"
                    >
                    <small
                        *ngIf="isControlValid('displayName')"
                        id="_displayName-help"
                        class="p-error block"
                    >
                        {{getErrorMessage('displayName') | translate}}
                    </small>
                </div>
                <!-- Base Line -->
                <div class="field col-3">

                    <label for="_baseline">{{'LABEL.BASELINE_YEAR' | translate}}</label>
                    <p-calendar
                        formControlName="baseline"
                        view="year"
                        dateFormat="yy"
                        inputId="yearpicker"
                        [readonlyInput]="true"
                        appendTo="body"
                        [placeholder]="'PLACEHOLDER.PROJECT_BASELINE_EX' | translate"
                        [ngClass]="{'ng-invalid ng-dirty' : isControlValid('baseline')}"
                    ></p-calendar>
                    <small
                        *ngIf="isControlValid('baseline')"
                        id="_baseline-help"
                        class="p-error block"
                    >
                        {{getErrorMessage('baseline') | translate}}
                    </small>
                </div>
                <!-- Period -->
                <div class="field col-3">
                    <label for="_period">{{'LABEL.FIRST_EXERCISE' | translate}}</label>
                    <p-calendar
                        formControlName="period"
                        view="month"
                        dateFormat="mm/yy"
                        [readonlyInput]="true"
                        inputId="monthpicker"
                        appendTo="body"
                        [placeholder]="'PLACEHOLDER.PROJECT_PERIOD_EX' | translate"
                        [ngClass]="{'ng-invalid ng-dirty' : isControlValid('period')}"
                    ></p-calendar>
                    <small
                        *ngIf="isControlValid('period')"
                        id="_period-help"
                        class="p-error block"
                    >
                        {{getErrorMessage('period') | translate}}
                    </small>
                </div>
                <!-- Organization -->
                <div class="field col-4">
                    <label for="organization">{{'LABEL.ORGANIZATION' | translate}}</label>
                    <p-dropdown
                        appendTo="body"
                        [ngClass]="{'ng-invalid ng-dirty' : isControlValid('organization')}"
                        [options]="organizations$ | async"
                        formControlName="organization"
                        optionLabel="name"
                        [filter]="true"
                        filterBy="name"
                        dataKey="id"
                        [showClear]="true"
                        [placeholder]="'PLACEHOLDER.SELECT_ORGANIZATION' | translate"
                    >
                        <ng-template pTemplate="footer">
                            <div class="text-right mb-1">
                                <button
                                    pButton
                                    type="button"
                                    [label]="'BUTTON.NEW_ORGANIZATION' | translate"
                                    icon="pi ri-add-line"
                                    class="p-button-text p-button-plain p-button-sm "
                                    (click)="onNewOrganization()"
                                ></button>
                            </div>
                        </ng-template>
                        <ng-template
                            let-organization
                            pTemplate="item"
                        >
                            <div class="flex align-items-center">
                                <div>{{organization.name}}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                    <small
                        *ngIf="isControlValid('organization')"
                        id="_organization-help"
                        class="p-error block"
                    >
                        {{getErrorMessage('organization') | translate}}
                    </small>
                </div>

                <!-- DiscountType -->
                <div class="field col-4">
                    <label for="_discountType">{{'LABEL.DISCOUNT_TYPE' | translate}}</label>
                    <p-dropdown
                        id="_discountType"
                        appendTo="body"
                        [ngClass]="{'ng-invalid ng-dirty' : isControlValid('discountType')}"
                        [options]="discountRatesOptions$ | async"
                        formControlName="discountType"
                        [placeholder]="'PLACEHOLDER.SELECT_DISCOUNT_TYPE' | translate"
                        optionValue="type"
                    >
                        <ng-template
                            let-discountType
                            pTemplate="selectedItem"
                            required
                        >
                            <div class="flex align-items-center">
                                <div *ngIf="!!discountType">
                                    {{"DISCOUNT_TYPE."+discountType.type | translate}} ({{discountType.discountRate30
                  |
                  percent:'1.2-2'}} / {{discountType.discountRate75 | percent:'1.2-2'}})
                                </div>
                            </div>
                        </ng-template>
                        <ng-template
                            let-discountType
                            pTemplate="item"
                        >
                            <div class="flex align-items-center">
                                <div>
                                    {{"DISCOUNT_TYPE."+discountType.type | translate}} ({{discountType.discountRate30 | percent:'1.2-2'}} /
                  {{discountType.discountRate75 | percent:'1.2-2'}})
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                    <small
                        *ngIf="isControlValid('discountType')"
                        id="_discountType-help"
                        class="p-error block"
                    >
                        {{getErrorMessage('discountType') | translate}}
                    </small>
                </div>

                <!-- Currency -->
                <div class="field col-4">
                    <label for="currency">{{'LABEL.CURRENCY' | translate}}</label>
                    <p-dropdown
                        #dropdown
                        appendTo="body"
                        [ngClass]="{'ng-invalid ng-dirty' : isControlValid('currency')}"
                        [options]="currencies$ | async"
                        optionValue="code"
                        filterBy="code,name"
                        [filter]="true"
                        formControlName="currency"
                        [placeholder]="'PLACEHOLDER.SELECT_CURRENCY' | translate"
                    >
                        <ng-template
                            let-item
                            pTemplate="item"
                        >
                            <div>
                                {{item.code}} ({{item.symbol}}) - {{item.name}}
                            </div>
                        </ng-template>
                        <ng-template
                            let-item
                            pTemplate="selectedItem"
                        >
                            <ng-container *ngIf="item">
                                <div>
                                    {{item.code}} ({{item.symbol}}) - {{item.name}}
                                </div>
                            </ng-container>
                        </ng-template>
                    </p-dropdown>
                    <small
                        *ngIf="isControlValid('currency')"
                        id="_currency-help"
                        class="p-error block"
                    >
                        {{getErrorMessage('currency') | translate}}
                    </small>
                </div>

                <!-- Public -->
                <div class="field col-6">
                    <label
                        for="_isPublic"
                        class="block"
                    >
                        {{'LABEL.PROJECT_IS_PUBLIC' | translate}}
                        <!-- <i pTooltip="This project's general summary will be visible in public website." tooltipPosition="top"
              class="text-primary mt-2 inline-block pi pi-info-circle">
            </i> -->
                    </label>
                    <p-inputSwitch
                        id="_isPublic"
                        formControlName="isPublic"
                    ></p-inputSwitch>
                </div>
            </div>

            <div class="field col-12">
                <label
                    for="_summary"
                    class="block"
                >
                    {{'LABEL.PROJECT_SUMMARY' | translate}}
                </label>
                <p-editor
                    formControlName="summary"
                    [style]="{'height':'150px'}"
                >
                    <ng-template pTemplate="header">
                        <span class="ql-formats">
                            <button
                                type="button"
                                class="ql-bold"
                                aria-label="Bold"
                            ></button>
                            <button
                                type="button"
                                class="ql-italic"
                                aria-label="Italic"
                            ></button>
                            <button
                                type="button"
                                class="ql-underline"
                                aria-label="Underline"
                            ></button>
                        </span>
                    </ng-template>
                </p-editor>
            </div>

            <!-- Actions -->
            <div
                [ngSwitch]="mode"
                class="col-12"
            >
                <div
                    *ngSwitchCase="'create'"
                    class="flex justify-content-end"
                >
                    <button
                        pButton
                        pRipple
                        [label]="'BUTTON.CREATE_PROJECT' | translate"
                        class="p-button-primary "
                    ></button>
                </div>
                <div
                    *ngSwitchCase="'edit'"
                    class="flex flex-row justify-content-between gap-3"
                >
                    <div>
                        <button
                            pButton
                            type="button"
                            pRipple
                            [label]="'BUTTON.CANCEL' | translate"
                            (click)="cancel()"
                            class="p-button-outline p-button-secondary p-button-text"
                        ></button>
                        <button
                            pButton
                            pRipple
                            [label]="'BUTTON.SAVE' | translate"
                            class="p-button-primary "
                        ></button>
                    </div>

                    <button
                        pButton
                        pRipple
                        type="button"
                        [label]="'BUTTON.DELETE' | translate"
                        class="p-button-text p-button-danger"
                        (click)="onDelete(project)"
                    ></button>
                </div>
            </div>

        </div>
    </form>
</ng-container>
<ng-template #elseTemplate>
    <h5>{{'LABEL.CREATING_PROJECT' | translate}}</h5>
    <p-progressBar
        mode="indeterminate"
        [style]="{'height': '6px'}"
    ></p-progressBar>
</ng-template>
